import SweepRulesListOptionState from './schema/SweepRulesListOptionState';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import SweepRuleRequestStatus from './schema/SweepRuleRequestStatus';

export default createStore<SweepRulesListOptionState>('sweepRulesOption', {
    hasLoggedGetSweepRulesInformation: false,
    getSweepRulesRequestStatus: SweepRuleRequestStatus.NotInitiated,
    sweepRules: new ObservableMap(),
    sweepRuleIds: [],
})();
